import { PlanInterface } from "./PlansInterface";
import { UserInterface } from "./UserInterfaces";

/**
 * subscription types. 3Pod currently have some of these.
 * membership types: ["funnels","designs","campaigns","video_hosting","ia_content","lifesaving"]
 * @typedef MembershipTypesInterface
 * @type {String}
 */
let MembershipTypesInterface;

/**
 * subscription types. 3Pod currently have some of these.
 * membership types: ["funnels","designs","campaigns","video_hosting","ia_content","lifesaving"]
 * @typedef MembershipTypesList
 * @type {Array.<{membership_type: String, icon: String, name: String}>}
 * 
 */
let MembershipTypesList = [
    {
        "membership_type": "funnels",
        "name": "Funnels & Websites",
        "altname": "Websites",
        "icon": "icon-tripod-T-plantilla"
    },
    {
        "membership_type": "designs",
        "name": "Diseño gráfico",
        "altname": "Diseños/G",
        "icon": "icon-tripod-v-designtools"
    },
    {
        "membership_type": "suite",
        "name": "Suite 3Pod",
        "altname": "Suite",
        "icon": "icon-tripod-T-plantilla"
    },
    {
        "membership_type": "suite_website",
        "name": "Suite Websites",
        "altname": "Suite Websites",
        "icon": "icon-tripod-T-world"
    },
    {
        "membership_type": "campaigns",
        "name": "Campañas",
        "altname": "Campañas",
        "icon": "icon-tripod-T-campaigns"
    },
    {
        "membership_type": "video_hosting",
        "name": "Administrador de vídeos",
        "altname": "Vídeos",
        "icon": "icon-tripod-T-admonvideo"
    },
    {
        "membership_type": "ia_content",
        "name": "Generador de contenidos IA",
        "altname": "IA",
        "icon": "icon-tripod-v-magicpen"
    },
    {
        "membership_type": "phone_line",
        "name": "Telefonía",
        "altname": "WhatsApp/SMS",
        "icon": "icon-tripod-whatsapp"
    },
    {
        "membership_type": "lifesaving",
        "name": "Salvavidas",
        "altname": "Salvavidas",
        "icon": "icon-tripod-lifebuoy"
    }
];
/**
 * 
 * @param {String} membership_type 
 * @returns {{membership_type: String, name: String, icon: String, altname: String}}
 */
const findMemberShipType = (membership_type)=>{
    return MembershipTypesList.find((item)=> item.membership_type === membership_type);
}

const getIntervalName = (interval_name) => {
    if(interval_name === 'month'){
        return 'Mensual'
    }else if(interval_name === 'year'){
        return 'Anual'
    }
}

const findSelectedPlanFromPlans = (plans, subscriptions) => {
    let selected_plan = false;
    plans.map((plan)=>{
        if(selected_plan){return;}
        selected_plan = subscriptions.find( // check selected plan.
            (subscription)=> subscription.membership_type === plan.membership_type && subscription.id_plan === plan.id_plan
        );
    })
}

let designServicesInterface = [
    {
        "type_of_service": "designs",
        "name": "Pieza gráfica",
        "icon": "icon-tripod-v-gallery",
        "available": true
    },
    {
        "type_of_service": "funnels",
        "name": "Embudo",
        "icon": "icon-tripod-v-filter",
        "available": false
    },
    {
        "type_of_service": "ecommerce",
        "name": "E-commerce",
        "icon": "icon-tripod-v-shop",
        "available": false
    },
    {
        "type_of_service": "landing",
        "name": "Landing page",
        "icon": "icon-tripod-T-plantilla",
        "available": false
    }
];


/**
 * Addons Interface. Addons can be different according to his nature.
 * @typedef AddonsInterface
 * @type {object}
 * @property {String} addon_type
 * @property {Number} limit
 * @property {String} name
 * @property {Number} price
 * @property {{amount: Number, currency: String, id: String, interval: String, product: Object}} price_plan
 * @property {String} product
 */
let AddonsInterface;

/**
 * 
 * @typedef PromotionsInterface
 * @type {object}
 * @property {MembershipTypesInterface} membership_type
 * @property {Number} type - (e.g ["discounts","trial"])
 * @property {Number} requests_left - requests left
 * @property {Number} percent_off - percent off
 */
let PromotionsInterface;

/**
 * Price Object for subscriptions
 * @typedef SubscriptionPricesIntervalsInterface
 * @type {object}
 * @property {Number} product - stripe_product_{id}
 * @property {Number} amount - unit amount in cents. for example $300USD will be -> 30.000 cents
 * @property {Number} interval - interval for this price. types: ["year","month"]
 */
let SubscriptionPricesIntervalsInterface;



/**
* @typedef SubscriptionsInterface
* @type {Object}
* @property {String} id - Unique subscription ID
* @property {Date} created_at - Creation timestamp
* @property {Date} updated_at - Last update timestamp
* @property {String} id_subscription - Subscription identifier from tripe
* @property {String} token - Subscription token
* @property {String} platform - Platform that can be stripe, paypal or other
* @property {String} owner - Owner (public_key) of the subscription
* @property {UserInterface} user - User object with necessary items generated by JOIN
* @property {Array.<AddonsInterface>} addons - Addons added to the plan
* @property {PromotionsInterface} promotion - Promotion data
 * @property {Number} current_period_start - Time in unixtime
 * @property {Number} current_period_end - Time in unixtime
 * @property {String} current_period_start_date - Formatted start date (e.g. "July 21, 2026 : 9:26 pm")
 * @property {String} current_period_end_date - Formatted end date (e.g. "August 21, 2026 : 9:26 pm")
 * @property {Array.<SubscriptionPricesIntervalsInterface>} prices - Array of price intervals
* @property {String} stripe_plan - Stripe plan ID
* @property {String} stripe_product - Stripe product ID
* @property {String} id_plan - Internal plan ID
* @property {Number|null} cancel_at - Cancel at this date
* @property {Boolean} cancel_at_period_end - Cancel when the period ends
* @property {Number|null} canceled_at - The date when the subscription has been canceled
* @property {MembershipTypesInterface} membership_type - Type of membership
* @property {String} currency - Currency code (USD as default)
* @property {String} status - Stripe membership status
* @property {Object} cancellation_reason - Cancellation reason data
* @property {Object} metadata - Additional metadata
* @property {String} trace - Trace information
 * @property {Number|null} trial_end - Trial end unixtime
 * @property {String|null} trial_end_date - Formatted trial end date
* @property {String} interval - Billing interval (month/year)
* @property {Date} cancel_at_date - Cancel date in UTC timezone
* @property {Date} canceled_at_date - Canceled date in UTC timezone
* @property {String} user_name - Full user name (first_name + last_name)
* @property {String} stripe_account - User's Stripe account
* @property {String} user_tags - User tags combined with campaign tag
* @property {Boolean} has_testing_tag - Flag indicating if user has testing tag
* @property {String} user_from_campaign - Campaign source
* @property {String} user_email - User's email address
* @property {Date} request_cancellation_at - Request cancellation date
* @property {Boolean} canceled_by_admin - Flag indicating if canceled by admin
* @property {Boolean} has_been_canceled - Flag indicating if subscription has been canceled
* @property {Boolean} cancel_at_period_end_status - Combined status for cancel_at_period_end
* @property {Number} total_spends - Total amount spent
* @property {Number} subscription_creations - Number of subscription creations
* @property {Number} subscription_updates - Number of subscription updates
* @property {Boolean} has_paid_transaction - Flag indicating if user has paid transaction
* @property {String} subscription_creations_desc - Description of subscription creations
* @property {String} billing_manager - ["EXTERNAL","INTERNAL"]
* @property {Number} total_funnels_v2 - Total number of funnels for suite memberships
* @property {PlanInterface|Object} plan - (Optional) can contain plan data
*/
let SubscriptionsInterface;

function parse_membership_name(membership_type){

    // on suite variants like suite_website return the same suite name.
    if(membership_type.search("suite")){
        return "suite";
    }
    return membership_type;
}


export {
    SubscriptionPricesIntervalsInterface,
    designServicesInterface,
    SubscriptionsInterface,
    MembershipTypesInterface,
    PromotionsInterface,
    MembershipTypesList,
    AddonsInterface,
    findMemberShipType,
    findSelectedPlanFromPlans,
    getIntervalName,
    parse_membership_name
}